import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { translate, formatData, getUserNameToName } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { Input, Button, Label, Title, Subtitle, BackButton } from '../../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import * as physicalConfirmationAction from '../../../../actions/physicalConfirmationAction';

const AreaConversionInsert = (props) => {
    const update = props.history?.location?.state?.update;
    const [areaConversion, setAreaConversion] = useState({});

    const onChange = (event) => {
        onValueChange(event, areaConversion, setAreaConversion);
    };

    useEffect(() => {
        if (!update) {
            setAreaConversion({});
            props.setAreaConversion({})
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (update) setAreaConversion(props?.areaConversion);

        // eslint-disable-next-line
    }, [props?.areaConversion]);

    const onConfirm = () => {
        if (update) {
            props.updateAreaConversion(areaConversion, (response) => {
                if (response) props.history.go(-1);
            });
        } else {
            props.addAreaConversion(areaConversion, (response) => {
                if (response) props.history.go(-1);
            })
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate("area-conversion", 'physical-confirmation')} />
                    <Subtitle icon="build" label={translate("new-area-conversion", 'physical-confirmation')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            label={translate("from", 'physical-confirmation')}
                                            id="areaFrom"
                                            name="areaFrom"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={areaConversion?.areaFrom}
                                            disabled={update}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            label={translate("to", 'physical-confirmation')}
                                            id="areaTo"
                                            name="areaTo"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={areaConversion?.areaTo}
                                        />
                                    </div>
                                </div>
                                {update &&
                                    <div className="row" style={{ marginBottom: '0px' }}>
                                        <Label label={translate('fields.updateBy', 'area')} id="updateBy" value={getUserNameToName(props.usersFromElog, areaConversion?.updateBy)} />
                                        <Label label={translate('fields.updateOn', 'area')} id="updateOn" value={formatData(areaConversion?.updateOn)} />
                                    </div>
                                }
                            </form>
                            <div className="row">
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        areaConversion: state.physicalConfirmationReducer.areaConversion,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAreaConversion: (dto, callback) => {
            dispatch(ChangeLocationService.addAreaConversion(dto, callback));
        },
        updateAreaConversion: (dto, callback) => {
            dispatch(ChangeLocationService.updateAreaConversion(dto, callback));
        },
        setAreaConversion: (area) => {
            dispatch(physicalConfirmationAction.setAreaConversion(area));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AreaConversionInsert)));
